<div class="text-b1-m-500 text-lg-b1-l-500">Проблемы с соединением</div>
<button [fullWidth]="false" sdButton [size]="buttonSize.Large" (click)="tryAgain()">Попробовать снова</button>
